import { render, staticRenderFns } from "./CollectVoucherTemplate.vue?vue&type=template&id=8d25430c"
import script from "./CollectVoucherTemplate.vue?vue&type=script&lang=js"
export * from "./CollectVoucherTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports